import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);
import { DrawSVGPlugin } from './DrawSVGPlugin.js';
gsap.registerPlugin(DrawSVGPlugin);

window.addEventListener('DOMContentLoaded', () => {
    selfFadeEffect('.js-fade__in');
    childrenFadeEffect('.js-fade__children');
    selfFadeEffectDelayed('.js-fade__in-delayed', 0.5);
    childrenFadeEffectDelayed('.js-fade__children-delayed', 0.5);

    // goToSection('details');
    // letterAnim('.property-management__content strong');
});

let selfFadeEffect = (target) => {
    // fade in animation for each defined element
    const fadeIn = document.querySelectorAll(target);
    if (fadeIn.length) {
        fadeIn.forEach((el) => {
            const fadeTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            fadeTl.fromTo(el, { yPercent: 5, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, ease: 'ease' });
        });
    }
};

let childrenFadeEffect = (target) => {
    // fade in animation for defined element's children
    const fadeChildren = document.querySelectorAll(target);
    if (fadeChildren.length) {
        fadeChildren.forEach((el) => {
            const showTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            showTl.fromTo(el.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: 0.5, ease: 'ease' });
        });
    }
};

let selfFadeEffectDelayed = (target, delay) => {
    // fade in animation for each defined element
    const fadeIn = document.querySelectorAll(target);
    if (fadeIn.length) {
        fadeIn.forEach((el) => {
            const fadeTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            fadeTl.fromTo(el, { yPercent: 5, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, delay: delay, ease: 'ease' });
        });
    }
};

let childrenFadeEffectDelayed = (target, delay) => {
    // fade in animation for defined element's children
    const fadeChildren = document.querySelectorAll(target);
    if (fadeChildren.length) {
        fadeChildren.forEach((el) => {
            const showTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            showTl.fromTo(el.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: delay, stagger: 0.5, ease: 'ease' });
        });
    }
};

function goToSection(element) {
    ScrollTrigger.create({
        trigger: '#' + element,
        start: 'top 40%',
        end: 'bottom 40%',
        scrub: false,
        // invalidateOnRefresh: true,
        onEnter: function () {
            jQuery('.property__nav--item').removeClass('active');
            jQuery('.' + element).addClass('active');
        },
        onEnterBack: function () {
            jQuery('.property__nav--item').removeClass('active');
            jQuery('.' + element).addClass('active');
        },
    });
}

// LETTER ANIMATION
let letterAnim = (el) => {
    let letterTlFrom, letterTlTo;
    const targets = document.querySelectorAll(el);

    letterTlFrom = {};
    letterTlTo = {
        textShadow: '-1px -1px 0 transparent, 1px -1px 0 transparent, -1px 1px 0 transparent, 1px 1px 0 transparent',
        color: '#4B92C1',
    };

    letterTlTo.duration = 0.5;
    letterTlTo.stagger = 0.05;
    letterTlTo.ease = 'none';

    if (targets.length) {
        targets.forEach((target, i) => {
            let letterTl = [];
            letterTl[i] = gsap.timeline({
                scrollTrigger: {
                    trigger: target,
                    start: 'top 75%',
                    end: '+=10%'
                },
            });
            letterTl[i].fromTo(target.children, letterTlFrom, letterTlTo);
        });
    }
};

const intro = document.querySelector('#intro');
if (intro) {
    let t1 = gsap.timeline({
        scrollTrigger: {
            trigger: '#intro',
            start: '0%',
            end: '80%',
            scrub: 1
        }
    });
    t1.fromTo('.circle', { scale: 1 }, { scale: 100, ease: 'ease'}, ">")
        .to('.intro__text--heading', { xPercent: -100, ease: 'power1.out', duration: 0.5 }, "<")
        .fromTo('.intro__text--scroll', { color: '#000000' }, { color: '#ffffff', ease: 'ease'}, "<")
        .fromTo('.home .document__header', { visibility: 'hidden', opacity: 0, top: '-100%' }, { visibility: 'visible', opacity: 1, top: 0, ease: 'ease'})
        .fromTo('.intro__text--scroll', { opacity: 1 }, { opacity: 0, ease: 'ease'});
}

const introDescription = document.querySelector('#intro-description');
if (introDescription) {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: '#intro-description',
            start: '-20% center',
            end: '80% center',
            scrub: 1
        }
    });
    tl.fromTo('.arrow__icon', { opacity: 0, visibility: 'hidden' }, { opacity: 1, visibility: 'visible', ease: 'ease'})
        .fromTo('.intro-description', { opacity: 0, visibility: 'hidden' }, { opacity: 1, visibility: 'visible', ease: 'ease'});
}

const dataDriven = document.querySelector('#data-driven');
if (dataDriven) {
    let t2 = gsap.timeline({
        scrollTrigger: {
            trigger: '#data-driven',
            start: '0% center',
            end: '100% center',
            scrub: 1
        }
    });
    t2.fromTo('.first-circle', {opacity: 0}, {opacity: 1})
        .fromTo('.second-circle', {opacity: 0}, {opacity: 1})
        .fromTo('.third-circle', {opacity: 0}, {opacity: 1})
        .fromTo('.fourth-circle', {opacity: 0}, {opacity: 1});
}

const caseStudies = document.querySelector('#case-studies');
if (caseStudies) {
    let t3 = gsap.timeline({
        scrollTrigger: {
            trigger: '#case-studies',
            start: '0% bottom',
            end: '20% bottom',
            scrub: true
        }
    });
    t3.fromTo('.homepage--icon', {opacity: 1, zIndex: 9}, {opacity: 0, zIndex: -1, ease: 'ease'});
}


const sectionBubbleWhite = document.querySelector('.section__bubble--white');
if (sectionBubbleWhite) {
    let t4 = gsap.timeline({
        scrollTrigger: {
            trigger: '.section__bubble--white',
            start: '0% top',
            end: '100% top',
            scrub: 1
        }
    });
    t4.to('.section__bubble--white', {clipPath: 'circle(75%)', height: '100%'});
}

const sectionBubbleBlack = document.querySelector('.section__bubble--black');
if (sectionBubbleBlack) {
    let t5 = gsap.timeline({
        scrollTrigger: {
            trigger: '.section__bubble--black',
            start: '0% top',
            end: '100% top',
            scrub: 1
        }
    });
    t5.to('.section__bubble--black', {clipPath: 'circle(75%)', height: '200%',});
}

// Change header items color according to background class
const lightBgSections = document.querySelectorAll('section.background--white:not(.intro) , .faq');
const headerHeight = document.querySelector('.document__header').offsetHeight;
if (lightBgSections) {
    lightBgSections.forEach((lightBgSection) => {
        ScrollTrigger.create({
            trigger: lightBgSection,
            start: `${headerHeight / 2} ${headerHeight}`,
            end: `100% ${headerHeight / 2}`,
            scrub: false,
            onEnter: () => document.querySelector('.document__header').classList.add('menu-dark'),
            onLeave: () => document.querySelector('.document__header').classList.remove('menu-dark'),
            onEnterBack: () => document.querySelector('.document__header').classList.add('menu-dark'),
            onLeaveBack: () => document.querySelector('.document__header').classList.remove('menu-dark'),
        });
    });
}

const caseStudyLinks = document.querySelectorAll('.case__study__link');
if (caseStudyLinks) {
    caseStudyLinks.forEach((caseStudyLink) => {
        caseStudyLink.addEventListener('mouseover', () => {
            gsap.to(caseStudyLink, {
                x: Math.random() * 150 - 100, // Random x-coordinate within a range
                y: Math.random() * 150 - 100, // Random y-coordinate within a range
                duration: 0.5,
            });
        });

        caseStudyLink.addEventListener('mouseout', () => {
            gsap.to(caseStudyLink, {
                x: 0,
                y: 0,
                duration: 0.5,
            });
        });
    });
}

const galleryItems = document.querySelectorAll('.single__gallery__img img');
// GSAP Animation
galleryItems.forEach((item) => {
    gsap.to(item, {
        scale: 1.08,
        scrollTrigger: {
            trigger: item,
            start: 'top center',
            end: 'bottom center',
            scrub: 1,
        },
    });
});